<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" />
        </div>

        <div class="mb-5">
          <div class="label-input">Layout</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.background"
                    @change="event => (fields.styleSection.background = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.background" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.textColor"
                    @change="event => (fields.styleSection.textColor = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.textColor" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.styleSection.topPadding" label="Padding top" :hide-details="true" />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.styleSection.bottomPadding" label="Padding bottom" :hide-details="true" />
              </v-col>

              <v-col cols="12" md="12">
                <v-checkbox v-model="fields.containerPage.enableStyle" label="Container Page" :hide-details="true" />
                <div v-if="fields.containerPage.enableStyle" class="mt-2">
                  <label>Container Background</label>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields.containerPage.background"
                      @change="event => (fields.containerPage.background = event.target.value)"
                    />
                    <v-text-field v-model="fields.containerPage.background" :hide-details="true" class="mt-0" />
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Card Title</label>
          <v-checkbox v-model="fields.cardTitle.show" label="Show title block" />
          <ckeditor
            v-if="fields.cardTitle.show"
            :editor="editor"
            v-model="fields.cardTitle.content"
            :config="editorConfig"
          />
        </div>

        <div class="mb-7">
          <div class="label-input">List Item</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label>Item Background</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.listStyle.bgItemColor"
                    @change="event => (fields.listStyle.bgItemColor = event.target.value)"
                  />
                  <v-text-field v-model="fields.listStyle.bgItemColor" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Item Radius (px)</label>
                <v-text-field
                  type="number"
                  v-model.number="fields.listStyle.borderItemRadius"
                  min="0"
                  suffix="px"
                  :rules="[v => v >= 0 || 'Border Radius must be greater than or equal 0']"
                  :hide-details="true"
                  class="mt-0"
                />
              </v-col>
            </v-row>
            <div class="d-flex justify-space-between align-center mb-2">
              <label style="margin-bottom: 0"></label>
              <v-btn small color="primary" @click="handleAddItem">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields.items" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Item {{ i + 1 }}</span>
                    <v-btn small icon @click.stop="handleRemoveItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-5">
                    <label>Image</label>
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, i)"
                      :image="{ imageSrc: item.image }"
                      :height="`150`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUpload(i)"
                    />
                  </div>
                  <div class="mb-3">
                    <label>Link</label>
                    <v-text-field v-model="item.link" />
                  </div>
                  <div class="mb-3">
                    <label>Content</label>
                    <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';

const defaultItem = () => ({
  link: '#',
  image: '',
  content: '<h3>Heading</h3><p>Description</p>',
});

const defaultFields = () => ({
  title: 'Card Hsia Text With Icon Section',
  styleSection: {
    topPadding: true,
    bottomPadding: true,
    background: '#FFFFFF',
    textColor: '#000000',
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  cardTitle: {
    show: true,
    content: '<h2>Title</h2><p>Description</p>',
  },
  listStyle: {
    bgItemColor: '#F5F5F5',
    borderItemRadius: '10px',
  },
  items: [defaultItem()],
});

export default {
  name: 'card-hsia-text-with-icon-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: defaultFields(),
    };
  },
  mounted() {
    const fallback = defaultFields();
    const extracted = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...fallback,
      ...extracted,
      styleSection: {
        ...fallback.styleSection,
        ...(extracted.styleSection || {}),
      },
      containerPage: {
        ...fallback.containerPage,
        ...(extracted.containerPage || {}),
      },
      cardTitle: {
        ...fallback.cardTitle,
        ...(extracted.cardTitle || {}),
      },
      listStyle: {
        ...fallback.listStyle,
        ...(extracted.listStyle || {}),
      },
      items: Array.isArray(extracted.items) && extracted.items.length ? extracted.items : fallback.items,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        items: (this.fields.items || []).filter(Boolean).map(item => ({
          link: item.link || '#',
          image: item.image || '',
          content: item.content || '',
        })),
      };

      if (!payload.items.length) {
        payload.items = [defaultItem()];
      }

      const updateHtml = updateHtmlFromData.sectionCardHsiaTextWithIcon(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: payload.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj, i) {
      this.fields.items[i].image = obj.imageSrc || '';
    },
    handleRemoveUpload(i) {
      this.fields.items[i].image = '';
    },
    handleAddItem() {
      this.fields.items.push(defaultItem());
    },
    handleRemoveItem(i) {
      if (this.fields.items.length <= 1) return;
      this.fields.items.splice(i, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.ck-editor__editable_inline {
  min-height: 200px;
}
.ck-editor__editable {
  min-height: 200px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
